/**
 * @prettier
 */
import { v3 as uuidv3 } from 'uuid';

export function fixedUuid(key: string | number): any {
    const uuid = uuidv3(key.toString(), uuidv3.DNS);
    return `${uuid.substring(0, 14)}4${uuid.substring(15)}`;
}
